import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Tab, Tabs } from '@mui/material';

import { HeaderTabs } from '@/layouts/Header';
import { ProfilePaths, useMatchLinks } from '@/shared/lib/react-router';

export const ProfileTabs = () => {
  const [matchedLink] = useMatchLinks(ProfilePaths.PERSONAL_INFO_PATH, ProfilePaths.ENTITY_INFO_PATH);
  const { t } = useTranslation('profile-page');

  return (
    <HeaderTabs>
      {matchedLink?.pathname && (
        <Tabs value={matchedLink.pathname} textColor="secondary" indicatorColor="secondary">
          <Tab
            component={Link}
            to={ProfilePaths.PERSONAL_INFO_PATH}
            value={ProfilePaths.PERSONAL_INFO_PATH}
            label={t('layout.profile-tabs.personal-info')}
          />
          <Tab
            component={Link}
            to={ProfilePaths.ENTITY_INFO_PATH}
            value={ProfilePaths.ENTITY_INFO_PATH}
            label={t('layout.profile-tabs.entity-info')}
          />
        </Tabs>
      )}
    </HeaderTabs>
  );
};
